__turbopack_context__.v({
  "table": "table-module-scss-module__gNMo6q__table",
  "tableBody": "table-module-scss-module__gNMo6q__tableBody",
  "tableCaption": "table-module-scss-module__gNMo6q__tableCaption",
  "tableCell": "table-module-scss-module__gNMo6q__tableCell",
  "tableElement": "table-module-scss-module__gNMo6q__tableElement",
  "tableFooter": "table-module-scss-module__gNMo6q__tableFooter",
  "tableHead": "table-module-scss-module__gNMo6q__tableHead",
  "tableHeader": "table-module-scss-module__gNMo6q__tableHeader",
  "tableRow": "table-module-scss-module__gNMo6q__tableRow",
});
